var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.707 17.293a1 1 0 0 0 1.414 1.414L12 12.828l5.879 5.879a1 1 0 0 0 1.414-1.414l-5.879-5.88L18.85 5.98a1 1 0 0 0-1.414-1.414L12 10 6.565 4.565A1 1 0 0 0 5.15 5.979l5.435 5.435z",
    clipRule: "evenodd"
  })));
};
export default SvgCross;